<template>
  <div class="home">
    <div class="home_top">
      <div class="inputbox">
        <div class="text">书名</div>
        <div class="line"></div>
        <div class="input">
          <el-input v-model="searchParams.title" placeholder=""> </el-input>
        </div>
      </div>
      <div class="inputbox">
        <div class="text">作者</div>
        <div class="line"></div>
        <div class="input">
          <el-input v-model="searchParams.author" placeholder=""> </el-input>
        </div>
      </div>
      <div class="inputbox">
        <div class="text">绘画</div>
        <div class="line"></div>
        <div class="input">
          <el-input v-model="searchParams.painting" placeholder=""> </el-input>
        </div>
      </div>
      <div class="inputbox">
        <div class="text">出版社</div>
        <div class="line"></div>
        <div class="input">
          <el-input v-model="searchParams.press" placeholder=""> </el-input>
        </div>
      </div>
      <div class="search" @click="goSerch">
        <img src="@/assets/image/search.png" alt="" />
      </div>
    </div>

    <div class="home_content">
      <div class="content_left">
        <div class="center_title">
          <img src="@/assets/image/lefttitle.png" alt="" />
        </div>
        <div class="class_type">
          <el-collapse v-model="openLv1" accordion>
            <!-- 一级循环 -->
            <template v-for="lv1 in classData">
              <!-- ① 有二级：正常用 el-collapse-item -->
              <el-collapse-item
                v-if="lv1.childrenList && lv1.childrenList.length"
                :key="lv1.guid"
                :name="lv1.guid"
              >
                <template slot="title">
                  <div class="lv1-title">{{ lv1.bookCategoryName }}</div>
                </template>

                <!-- 二级区域 -->
                <div v-for="lv2 in lv1.childrenList" :key="lv2.guid">
                  <!-- 二级标题 -->
                  <div
                    class="fake-item"
                    @click.stop="
                      hasThree(lv2) ? toggleLv2(lv2.guid) : goDetail(lv2)
                    "
                  >
                    <span>{{ lv2.bookCategoryName }}</span>
                    <i
                      v-if="hasThree(lv2)"
                      :class="
                        openLv2 === lv2.guid
                          ? 'el-icon-arrow-down'
                          : 'el-icon-arrow-right'
                      "
                      style="margin-left: auto"
                    />
                  </div>

                  <!-- 三级折叠容器（只占位，不显示标题） -->
                  <el-collapse v-if="hasThree(lv2)" v-model="openLv2" accordion>
                    <el-collapse-item :name="lv2.guid" style="display: none" />
                  </el-collapse>

                  <!-- 三级内容 -->
                  <div
                    v-show="openLv2 === lv2.guid && hasThree(lv2)"
                    class="three_level"
                  >
                    <div
                      v-for="lv3 in lv2.childrenList"
                      :key="lv3.guid"
                      class="three_item"
                      @click.stop="goDetail(lv3)"
                    >
                      {{ lv3.bookCategoryName }}
                    </div>
                  </div>
                </div>
              </el-collapse-item>

              <!-- ② 无二级：直接渲染成普通节点，无箭头 -->
              <div
                v-else
                :key="'no-children-' + lv1.guid"
                class="lv1-title no-children"
                @click="goDetail(lv1)"
              >
                {{ lv1.bookCategoryName }}
              </div>
            </template>
          </el-collapse>
        </div>
      </div>
      <div class="content_center">
        <div class="one">
          <div class="title_top">
            <div class="title_content oneimg brown">
              {{ (moduleName[0] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList(moduleData[0])">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>
          <div class="one_list">
              <div
                class="list_item"
                 v-for="(item, index) in moduleData[0]?.list?.slice(0, 3) || []"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">
                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                    <!-- 悬停蒙版 -->
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <!-- 收藏按钮保持不动 -->
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                    />
                  </div>


                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
          </div>
          <div class="line_dashed"></div>
          <div class="one_list">
              <div
                class="list_item"
                v-for="(item, index) in moduleData[0].list.slice(3, 6)"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">
                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                    <!-- 悬停蒙版 -->
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <!-- 收藏按钮保持不动 -->
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                    />
                  </div>


                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
          </div>
        </div>
        <div class="two">
          <div class="title_top">
            <div class="title_content twoimg blue">
              {{ (moduleName[1] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList(moduleData[1])">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>
          <div class="two_list">
            <!-- 左侧大图：取第 1 条，最多只显示 1 个 -->
            <div
              class="two_list_left"
              v-if="(moduleData[1]?.list || []).length"
              @click="goReader(moduleData[1].list[0])"
            >
              <!-- 图片容器 -->
              <div class="img-box">
                <img :src="moduleData[1].list[0]?.resourceCover || ''" alt="" />

                <!-- 收藏按钮保持不动 -->
                <div
                  class="collect"
                  @click.stop="goCollect(moduleData[1].list[0])"
                >
                  <img
                    class="collectimg"
                    :src="
                      moduleData[1].list[0]?.collected === 1
                        ? require('@/assets/image/collectactive.png')
                        : require('@/assets/image/collect.png')
                    "
                  />
                </div>

                <!-- 悬停蒙版 -->
                <div class="mask">
                  <div class="mask-txt">

                      <p class="press " style="font-size:0.2rem"> 书名：{{ moduleData[1].list[0]?.title }}</p>
                      <p class="author" style="font-size:0.2rem">作者：{{ moduleData[1].list[0]?.author }}</p>
                      <p class="press" style="font-size:0.2rem"> 绘画：{{ moduleData[1].list[0]?.painting }}</p>
                      <p class="press" style="font-size:0.2rem">
                        出版社：{{ moduleData[1].list[0]?.press }}
                      </p>
                      <p class="author" style="font-size:0.2rem">
                        出版时间：{{
                          moduleData[1].list[0]?.publicationDate
                            ? moduleData[1].list[0]?.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                  </div>
                </div>
              </div>

              <div class="title ellipsis">
                {{ moduleData[1].list[0]?.title || "" }}
              </div>
            </div>

            <!-- 右侧小图：从第 2 条开始，最多 3 个 -->
            <div class="two_list_right">
              <div
                class="right_item"
                 v-for="(item, idx) in (moduleData[1]?.list || []).slice(1, 5)"
                :key="idx"
                @click="goReader(item)"
              >
                <!-- 图片容器 -->
                <div class="img-box">
                  <img :src="item.resourceCover" alt="">

                  <!-- 收藏按钮 -->
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="item.collected === 1
                            ? require('@/assets/image/collectactive.png')
                            : require('@/assets/image/collect.png')"
                    >
                  </div>

                  <!-- 悬停蒙版 -->
                  <div class="mask">
                    <div class="mask-txt" style="font-size:0.11rem">

                      <p class="press ellipsis" style="width:1.5rem;"> 书名：{{ item.title }}</p>
                      <p class="author">作者：{{ item.author }}</p>
                      <p class="press ellipsis" style="width:1.5rem"> 绘画：{{ item.painting }}</p>
                      <p class="press ellipsis" style="width:1.5rem">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="title ellipsis">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="one three">
          <div class="title_top">
            <div class="title_content threeimg pink">
              {{ (moduleName[2] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList(moduleData[2])">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>
          <div class="one_list">
              <div
                class="list_item"
                 v-for="(item, index) in moduleData[2]?.list?.slice(0, 3) || []"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">
                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                    <!-- 悬停蒙版 -->
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <!-- 收藏按钮保持不动 -->
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                    />
                  </div>


                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
          </div>
          <div class="line_dashed"></div>
          <div class="one_list">
              <div
                class="list_item"
                v-for="(item, index) in moduleData[2].list.slice(3, 6)"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">
                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                    <!-- 悬停蒙版 -->
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <!-- 收藏按钮保持不动 -->
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                    />
                  </div>


                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
          </div>
        </div>
        <!-- <div class="three">
          <div class="title_top">
            <div class="title_content threeimg pink">
              {{ (moduleName[2] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>

          <div class="one_list mySwipertwo">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide list_item"
                v-for="(item, index) in moduleData[2].list.slice(0, 4)"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">

                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press"> 名称：{{ item.title }}</p>
                      <p class="author">作者：{{ item.author }}</p>
                      <p class="press"> 绘画：{{ item.painting }}</p>
                      <p class="press">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="one four">
          <div class="title_top">
            <div class="title_content  fourimg blue">
              {{ (moduleName[3] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click.stop="goList(moduleData[3])">
              11更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>
          <div class="one_list">
              <div
                class="list_item"
                 v-for="(item, index) in moduleData[3]?.list?.slice(0, 3) || []"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">
                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                    <!-- 悬停蒙版 -->
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <!-- 收藏按钮保持不动 -->
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                    />
                  </div>
                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
          </div>
          <div class="line_dashed"></div>
          <div class="one_list">
              <div
                class="list_item"
                v-for="(item, index) in moduleData[3].list.slice(3, 6)"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">
                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                    <!-- 悬停蒙版 -->
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <!-- 收藏按钮保持不动 -->
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                    />
                  </div>


                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
          </div>
        </div>
        <!-- <div class="four">
          <div class="title_top">
            <div class="title_content fourimg blue">
              {{ (moduleName[3] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>

          <div class="one_list mySwiperthree">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide list_item"
                v-for="(item, index) in moduleData[3].list.slice(0, 4)"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">
                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                  <div class="mask">
                    <div class="mask-txt">
                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="mask">
                    <div class="mask-txt">
                      <p class="press"> 书名：{{ item.title }}</p>
                      <p class="author">作者：{{ item.author }}</p>
                      <p class="press"> 绘画：{{ item.painting }}</p>
                      <p class="press">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="five">
          <div class="title_top">
            <div class="title_content fiveimg brown">
              {{ (moduleName[4] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList(moduleData[4])">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>

          <div class="one_list">
              <div
                class="list_item"
                v-for="(item, index) in moduleData[4].list.slice(0, 3)"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">

                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press"> 名称：{{ item.title }}</p>
                      <p class="author">作者：{{ item.author }}</p>
                      <p class="press"> 绘画：{{ item.painting }}</p>
                      <p class="press">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
          </div>
        </div>
        <div class="five">
          <div class="title_top">
            <div class="title_content siximg yellow">
              {{ (moduleName[5] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList(moduleData[5])">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>

          <div class="one_list">
              <div
                class="list_item"
                v-for="(item, index) in moduleData[5].list.slice(0, 3)"
                :key="index"
                @click="goReader(item)"
              >
                <div class="cover_item">

                  <div class="img_box">
                    <img :src="item.resourceCover" alt="" />
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author ellipsis smallsize">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author ellipsis smallsize">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  </div>
                  <div class="collect" @click.stop="goCollect(item)">
                    <img
                      class="collectimg"
                      :src="
                        item.collected === 1
                          ? require('@/assets/image/collectactive.png')
                          : require('@/assets/image/collect.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="mask">
                    <div class="mask-txt">

                      <p class="press"> 名称：{{ item.title }}</p>
                      <p class="author">作者：{{ item.author }}</p>
                      <p class="press"> 绘画：{{ item.painting }}</p>
                      <p class="press">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="title ellipsis">{{ item.title }}</div>
              </div>
          </div>
        </div>
        <!-- <div class="five">
          <div class="title_top">
            <div class="title_content fiveimg brown">
              {{ (moduleName[4] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>
          <div class="five_list">
            <div
              class="item"
              v-for="(item, index) in moduleData[4].list.slice(0, 4)"
              :key="index"
              @click="goReader(item)"
            >
              <div class="cover">
                <img :src="item.resourceCover" alt="" />
                <div class="collect" @click.stop="goCollect(item)">
                  <img
                    class="collectimg"
                    :src="
                      item.collected === 1
                        ? require('@/assets/image/collectactive.png')
                        : require('@/assets/image/collect.png')
                    "
                    alt=""
                  />
                </div>
                <div class="masks">
                  <div class="mask_txt">
                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                      <p class="author smallsize ellipsis">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                      <p class="press smallsize ellipsis">
                        出版社：{{ item.press }}
                      </p>
                      <p class="author smallsize ellipsis">
                        出版时间：{{
                          item.publicationDate
                            ? item.publicationDate.split(" ")[0]
                            : ""
                        }}
                      </p>
                  </div>
                </div>
              </div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->
        <!-- <div class="five">
          <div class="title_top">
            <div class="title_content siximg yellow">
              {{ (moduleName[5] || {}).bookCategoryName || "暂无分类" }}
            </div>
            <div class="more" @click="goList">
              更多<img src="@/assets/image/more.png" alt="" />
            </div>
          </div>

          <div class="five_list">
            <div
              class="item"
              v-for="(item, index) in (moduleData[5].list || []).slice(0, 4)"
              :key="index"
              @click="goReader(item)"
            >
              <div class="cover">
                <img :src="item.resourceCover" alt="" />

                <div class="collect" @click.stop="goCollect(item)">
                  <img
                    class="collectimg"
                    :src="
                      item.collected === 1
                        ? require('@/assets/image/collectactive.png')
                        : require('@/assets/image/collect.png')
                    "
                  />
                </div>


                <div class="masks">
                  <div class="mask_txt">
                      <p class="press smallsize ellipsis"> 书名：{{ item.title }}</p>
                    <p class="author smallsize ellipsis">作者：{{ item.author }}</p>
                      <p class="press smallsize ellipsis"> 绘画：{{ item.painting }}</p>
                    <p class="press smallsize ellipsis">
                      出版社：{{ item.press }}
                    </p>
                    <p class="author smallsize ellipsis">
                      出版时间：{{
                        item.publicationDate
                          ? item.publicationDate.split(" ")[0]
                          : ""
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="content_right">
        <div class="pushtext">
          <img src="@/assets/image/push.png" alt="" />
        </div>
        <div class="push_list">
          <div
            class="push_item"
            v-for="(item, index) in recommendList"
            :key="index"
            @click="goReader(item)"
          >
            <div class="push_cover">
              <img :src="item.resourceCover" alt="" />
            </div>
            <div class="title ellipsis">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="seemore" @click="goMore" v-if="recommendList.length>0">
          <img src="@/assets/image/seemore.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import remToggle from "@/utils/rem-toggle.js";

import {
  getSelect,
  queryList,
  homeQueryList,
  addView,
  addBookView,
  addCollect,
  delectCollect, addSearch,
} from "@/api/basics/banner";

export default {
  mixins: [remToggle],
  data() {
    return {
      input: "",
      searchParams: {
        press: "",
        title: "",
        author: "",
        painting: "",
      },
      activeNames: ["1"], // 一级=       // 二级-Feedback
      activeNames: ["1"], // 一级
      sub1: ["1-1"], // 二级-Consistency
      "sub1-1": ["1-1-1"], // 三级-设计原则（用引号解决横杠）
      sub2: [],
      classData: [],
      openLv1: [], // 第一层当前展开项
      openLv2: [], // 第二层当前展开项（accordion 模式）
      moduleName: [],
       moduleData: {
      // 每个模块初始化为 { list: [] }，避免list为undefined
      0: { list: [] },
      1: { list: [] },
      2: { list: [] },
      3: { list: [] },
      4: { list: [] },
      5: { list: [] },
      6: { list: [] },
    },
      // moduleData:{},
      recommendList: [],

      queryParams: {
        pageNum: 1,
        pageSize: 4,
      },
      userInfo: "",
    };
  },
  created() {
    const user = this.$store.state.userInfo;
    // console.log(user, "11用户信息");
    if (user && user.rdname) {
      // console.log('1111111');
      this.userInfo = user;
    } else {
      this.userInfo = "";
    }
    this.getTypeClass();
    this.getRecommend();
  },
  mounted() {
    this.initSwiper();
  },
  updated(){
    // this.initSwiper();
  },
  methods: {
    getTypeClass() {
      const params = {
        module: 222,
      };
      getSelect(params).then((res) => {
        // console.log("分类", res.data.data);
        this.classData = res.data.data || [];
        this.moduleName = res.data.data || [];
        this.moduleName.forEach((cate, idx) => {
          if (cate.guid) this.getListData(idx, cate.guid);
        });
        // this.getListData()
      });
    },
    handleChange(val) {
      // console.log('当前展开的一级面板：', val);
    },
    // getListData(index, guid) {
    //   const params = {
    //     bookCategoryId: guid,
    //     ...this.queryParams,
    //   };
    //   homeQueryList(guid).then((res) => {
    //     // console.log("查询列表数据", res.data.data);
    //     this.$set(this.moduleData, index, res.data.data || []);
    //     // console.log('1111this.moduleData',this.moduleData[0].list);
    //   });
    // },
    getListData(index, guid) {
  const params = {
    bookCategoryId: guid,
    ...this.queryParams,
  };
  homeQueryList(guid).then((res) => {
    // 兜底：如果返回数据没有list，默认给空数组
    const data = res.data.data || { list: [] };
    this.$set(this.moduleData, index, data);
  });
},

    // 查询推荐数据
    getRecommend() {
      const params = {
        recommend: 1,
        pageSize: 5,
      };
      queryList(params).then((res) => {
        // console.log("查询推荐数据", res);
        this.recommendList = res.data.rows;
      });
    },
    goList(item) {
      // console.log("item", item);
      this.$router.push({
        path: "/List",
        query: {
          // guid: item.guid,
          guid: item.nextCategoryGuid,
          // fromId:this.fromId
        },
      });
    },
    initSwiper() {
      var swiper = new Swiper(".mySwiper", {
        pagination: ".swiper-pagination",
        slidesPerView: 4,
        // centeredSlides: true,//居中
        paginationClickable: true,
        spaceBetween: 20,
      });

      var swiper = new Swiper(".mySwipertwo", {
        pagination: ".swiper-pagination",
        slidesPerView: 3,
        loop: true,

        autoplay: {
          delay: 2000, //2秒切换一次
          disableOnInteraction: false,
        },
        centeredSlides: true, //居中
        paginationClickable: true,
        spaceBetween: 50,
        slideToClickedSlide: true, // 点击任意一张也能切换
      });

      var swiper = new Swiper(".mySwiperthree", {
        pagination: ".swiper-pagination",
        slidesPerView: 5,
        // loop: true,
        centeredSlides: true, //居中
        paginationClickable: true,
        spaceBetween: 20,
      });
    },
    goDetail(node) {
      this.$router.push({
        path: "/List",
        query: {
          guid: node.guid,
        },
      });
    },
    goReader(item) {
      if (this.userInfo) {
        this.addViews(item);
        this.addBookViewZi(item);
        const q = new URLSearchParams({
          resourceLinks: item.resourceLinks,
          guid: item.guid,
          title: item.title,
          number: item.number,
          p: 1,
          m: 0,
          width: 800,
          height: 600,
          pagecount: 20,
        }).toString();
        window.open(`/Cloud-PC/book/Reader/ReadBook.html?${q}`, "_blank");
        // window.open(`/book/Reader/ReadBook.html?${q}`, "_blank");
      } else {
        this.$message.error("请登录后再进行阅读！");
        this.$router.push({
          path: "/User/Login",
        });
      }
    },

    // 查询推荐数据
    addViews(item) {
      const params = {
        type: 1,
        module: 222,
        resourceId: item.guid,
        categoryId: item.bookCategoryId,
      };
      addView(params).then((res) => {
        // console.log("浏览量res", res);
      });
    },

    goCollect(item) {
      // console.log('收藏');
      if (this.userInfo) {
        if (item.collected == 1) {
          delectCollect([item.guid]).then((res) => {
            // console.log('取消收藏',res);
            if (res.data.code == 200) {
              this.$message.success("取消收藏成功");
              this.getTypeClass();
            }else{
              this.$message.error(res.data.msg);
              this.$router.push({
                path: "/User/Login",
              });
            }
          });
        } else {
          const params = {
            module: 222,
            resourceId: item.guid,
          };
          addCollect(params).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("收藏成功");
              this.getTypeClass();
            }else{
              this.$message.error(res.data.msg);
              this.$router.push({
                path: "/User/Login",
              });
            }

          });
        }
      } else {
        this.$message.error("请登录后再进行收藏！");
        this.$router.push({
          path: "/User/Login",
        });
      }
    },
    // 增加当前书的阅读足迹
    addBookViewZi(item) {
      const params = {
        module: 222,
        resourceId: item.guid,
        resourceLinks: item.resourceLinks,
        number: item.number,
      };
      addBookView(params).then((res) => {
        // console.log("阅读足迹", res);
      });
    },
    // 判断有没有三级
    hasThree(lv2) {
      return lv2.childrenList && lv2.childrenList.length;
    },

    toggleLv2(guid) {
      this.openLv2 = this.openLv2 === guid ? "" : guid;
    },
    handleNoThree(lv2) {
      this.openLv2 = ""; // 保证其它二级面板收起
      this.goDetail(lv2);
    },
    goSerch() {
      // 检查所有搜索字段是否都为空
      const { press, title, author, painting } = this.searchParams;
      if (!press && !title && !author && !painting) {
        this.$message.error("请输入搜索关键词");
        return; // 终止函数执行
      }

      // const params = {
      //   ...this.searchParams,
      // };
      this.$router.push({
        path: "/List",
        query: {
          // params: params,
          ...this.searchParams,
        },
      });
    },
    goMore(){
      this.$router.push({
        path: "/MoreList",
      });
    }
  },
};
</script>

<style scoped lang="less">
.home {
  width: 13.639rem;
  margin: auto;
  margin-top: 0.40rem;
  .home_top {
    display: flex;
    // justify-content: space-between;
    .inputbox {
      width: 2.7rem;
      height: 0.6rem;
      border-radius: 0.1rem;
      background: #ffffff;
      border: 0.02rem solid #4b3331;
      margin-right: 0.32rem;
      display: flex;
      align-items: center;
      .text {
        font-size: 0.20rem;
        color: #666666;
        margin-left: 0.08rem;
      }
      .line {
        width: 0.02rem;
        height: 0.43rem;
        background-color: #666666;
        margin: 0 0.09rem;
      }
      .input {
        height: 1rem;
          flex: 1;               // 占满剩余宽度
          height: 100%;          // 继承父级 0.6 rem
          display: flex;         // 让 el-input 垂直居中
          align-items: center;
          border: none;          // 调试用，可删
        }
        /deep/.el-input__inner {
          font-size: 0.2rem;
           border: none;
           height: 0.36rem;
        }
    }
    .search {
      width: 1.63rem;
      height: 0.60rem;
      cursor: pointer;
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
  .home_content {
    display: flex;
    justify-content: space-between;
    margin-top: 0.29rem;
    .content_left {
      // max-width: 320px;
      width: 15%;
      width: 15%;
      // width: ;
      height: 13.22rem;
      overflow-y: auto;
      background: url(@/assets/image/left.png) center center no-repeat;
      background-size: 100% 100%;
      // border: 6px solid #836c4e;
      border-radius: 0.10rem;
      .center_title {
        width: 1.59rem;
        height: 0.61rem;
        margin-top: 0.06rem;
        margin-left: 0.22rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .class_type {
        width: 2rem;
        margin-top: 0.26rem;
        padding-left: 0.25rem;
        box-sizing: border-box;
        .no-children {
          display: flex;
          align-items: center;
          height: 0.65rem;
          line-height: 0.65rem;
          cursor: pointer;
          // font-size: 20px;
          font-size: 0.2rem;
          color: #303133;
          transition: background 0.5s;
          margin-bottom: 0.05rem;
          border-top: 0.02rem dashed #FF6600;
          width: 92%;
        }
        .fake-item {
          width: 93%;
          display: flex;
          align-items: center;
          height: 0.48rem;
          line-height: 0.48rem;
          padding: 0 0.12rem 0 0.1rem;
          cursor: pointer;
          // font-size: 20px;
          font-size: 0.2rem;
          color: #303133;
          transition: background 0.5s;
          margin-bottom: 0.05rem;

          border-radius: 0.1rem;
        }
        .fake-item:hover {
          border-radius: 0.1rem;
          background: #FF6600;
          // font-size: 20px;
          font-size: 0.2rem;
          color: #ffffff;
        }
        /* 三级条目样式保持不变 */
        .three_level {
          padding: 0.08rem 0 0.08rem 0.24rem;
        }
        .three_item {
          padding: 0.06rem 0;
          cursor: pointer;
          // font-size: 13px;
          font-size: 0.13rem;
        }
        .three_item:hover {
          color: #409eff;
        }
        /deep/ .el-collapse {
          border-bottom: none;
        }
        /deep/ .el-collapse-item__header {
          width: 92%;
          height: 0.65rem;
          background-color: transparent;
          border-top: 0.02rem dashed #FF6600;
          // font-size: 20px;
          font-size: 0.2rem;
          color: #333333;
        }
        /deep/.el-collapse-item__arrow{
          color: #FF6600;
        }
        .el-icon-arrow-right{
          color: #FF6600;
        }
        /deep/ .el-collapse-item__header:first {
          border-top: none !important;
        }
        /deep/ .el-collapse-item__wrap {
          background-color: transparent !important;
          border-bottom: 0.01rem solid #ddd7cb;
        }
        /deep/ .el-collapse {
          border-top: 0.01rem solid #ddd7cb !important;
        }
        /deep/ .el-collapse-item__header {
          border-bottom: 0.01rem solid #ddd7cb;
          font-weight: normal;
        }
        .three_level {
          display: flex;
          flex-wrap: wrap;
        }
        .three_level div {
          position: relative;
          padding: 0 0.15rem;
          // font-size: 18px;
          font-size: 0.18rem;
          color: #666666;
          margin-bottom: 0.19rem;
          cursor: pointer;
        }
        .three_level div::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 60%;
          width: 0.02rem;
          background-color: #bbbbbb;
        }
        .two_level {
          width: 2.55rem;
          // height: 49px;
          // line-height: 49px;
          border-radius: 0.10rem;
          // background: #4b3331;
          color: #fff;
          // font-size: 20px;
          font-size: 0.2rem;
          // font-weight: bold;
          cursor: pointer;
          // padding-left: 10px;
          box-sizing: border-box;
        }
      }
    }
    .content_center {
      width: 8.569rem;
      min-height: 2.99rem;
      .one {
        width: 8.74rem;
        height: 5.6rem;
        background-image: url(@/assets/image/center1.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .one_list {
          width: 8.089rem;
          margin: auto;
          margin-top: 0.18rem;
          display: flex;
          flex-wrap: wrap;
          .list_item {
            width: 2.6rem;
            height: 2.06rem;
            cursor: pointer;
            margin-right: 0.14rem;
            .cover_item {
              width: 2.6rem;
              // height: 1.359rem;
              height: 1.67rem;
              position: relative;
              .img_box {
                position: relative;
                width: 2.6rem;
                height: 1.67rem;
                border-radius: 0.109rem;
                overflow: hidden;          /* 让蒙版不会溢出圆角 */
              }

                .img_box img {
                  width: 100%;
                  height: 100%;
                  display: block;
                  border-radius: inherit;
                }
                .img_box:hover .mask {
                  opacity: 1;
                  transform: translateY(0);
                }
                .collect {
                    position: relative;
                    z-index: 999;
                    bottom: 1.6rem;
                    left: 2.2rem;
                    width: 0.29rem;
                    height: 0.29rem;
                    .collectimg {
                      width: 100%;
                      height: 100%;
                      display: block;
                    }
                }
              }
            .title {
              font-size: 0.18rem;
              color: #3d3d3d;
              margin-top: 0.1rem;
            }
          }
          .list_item:nth-child(3n){
            margin-right: 0;
          }


        }
        .line_dashed {
          width: 7.91rem;
          border: 0.02rem dashed #94857E;
          margin: auto;
          margin-top: 0.2rem;
          margin-bottom: 0.2rem;
        }
      }
      .two {
        width: 8.74rem;
        // height: 3.8rem;
        height: 4.3rem;
        background-image: url(@/assets/image/center2.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-top: 0.30rem;
        .two_list {
          display: flex;
          width: 8.1rem;
          margin: auto;
          justify-content: space-between;

          margin-top: 0.12rem;
          .two_list_left {
            position: relative; /* 让收藏、蒙版都相对它定位 */
            width: 4.18rem;
            cursor: pointer;
            /* 图片容器 */
            .img-box {
              position: relative;
              width: 100%;
              height: 2.98rem;
              border-radius: 0.10rem;
              overflow: hidden; /* 蒙版超出圆角部分隐藏 */
              box-shadow: 0 0.04rem 0.1rem 0 #765021;
              img {
                width: 4.18rem;
                height: 100%;
                object-fit: cover;
                border-radius: 0.10rem;
              }

              /* 收藏按钮 */
              .collect {
                position: absolute;
                bottom: 3.3rem;
                right: 0.1rem;
                width: 0.3rem;
                height: 0.3rem;
                z-index: 2; /* 保证在蒙版之上 */
                .collectimg {
                  width: 100%;
                  height: 100%;
                }
              }

            }
               .img-box:hover .mask {
                transform: translateY(0);
                opacity: 1;
              }

            .title {
              font-size: 0.16rem;
              color: #3d3d3d;
              margin-top: 0.04rem;
            }
            .mask-txt {
              line-height: 1.6;
            }
          }

          .two_list_right {
            width: 4.18rem;
            margin-left: 0.16rem;
            display: flex;
            flex-wrap: wrap;
            .right_item {
              position: relative;
              width: 1.78rem;
              height: 1.37rem;
              margin-bottom: 0.35rem;
              margin-right: 0.2rem;
              cursor: pointer;
              .img-box {
                position: relative;
                width: 100%;
                height: 1.27rem;
                border-radius: 0.1rem;
                overflow: hidden;
              }
              img {
                width: 100%;
                height: 100%;
                border-radius: 0.1rem;
                display: block;
              }
              .collect {
                position: relative;
                z-index: 999;
                bottom: 1.20rem;
                left: 1.48rem;
                width: 0.25rem;
                height: 0.25rem;
                .collectimg {
                  width: 100%;
                  height: 100%;
                }
              }
              .title {
                font-size: 0.16rem;
                color: #3d3d3d;
                margin-top: 0.04rem;
              }
            }
            /* 悬停出现 */
            .right_item:hover .mask {
              transform: translateY(0);
              opacity: 1;
            }
            .right_item:nth-child(2n) {
              margin-right: 0;
              margin-bottom: 0;
            }
          }
        }
      }
      .three {
        // width: 8.74rem;
        // height: 3.05rem;
        // background-image: url(@/assets/image/center3.png);
        // background-size: 100% 100%;
        // background-repeat: no-repeat;
        margin-top: 0.3rem;
        // .one_list {
        //   width: 8.01rem;
        //   margin: auto;
        //   margin-top: 0.18rem;
        //   overflow: hidden;
        //   .swiper-slide {
        //     width: 1.9rem;
        //     height: 1.62rem;
        //   }
        //   .list_item {
        //     width: 1.9rem !important;
        //     height: 1.79rem;
        //     cursor: pointer;
        //     margin-right: 0.13rem;

        //     .cover_item {
        //       width: 1.859rem;
        //       height: 1.359rem;
        //       position: relative;
        //       .img_box {
        //         position: relative;
        //         width: 1.859rem;
        //         height: 1.359rem;
        //         border-radius: 0.109rem;
        //         overflow: hidden;          /* 让蒙版不会溢出圆角 */
        //       }

        //         .img_box img {
        //           width: 100%;
        //           height: 100%;
        //           display: block;
        //           border-radius: inherit;
        //         }
        //         .img_box:hover .mask {
        //           opacity: 1;
        //           transform: translateY(0);
        //         }
        //         .collect {
        //             position: relative;
        //             z-index: 999;
        //             bottom: 2.1rem;
        //             left: 1.459rem;
        //             width: 0.29rem;
        //             height: 0.29rem;
        //             .collectimg {
        //               width: 100%;
        //               height: 100%;
        //             }
        //         }
        //       }
        //     .title {
        //       // font-size: 18px;
        //       font-size: 0.18rem;
        //       color: #3d3d3d;
        //       margin-top: 0.10rem;
        //     }
        //   }
        //   .list_item:nth-child(4n){
        //     margin-right: 0;
        //   }

        //   /* 悬停出现 */
        //   // .list_item:hover .mask {
        //   //   transform: translateY(0);
        //   //   opacity: 1;
        //   // }
        // }
      }
      .four {
        margin-top: 0.30rem;
      }
      .five{
        width: 8.74rem;
        height: 3.05rem;
        background-image: url(@/assets/image/center3.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-top: 0.3rem;
        .one_list {
          width: 8.01rem;
          margin: auto;
          margin-top: 0.18rem;
          display: flex;
          .list_item {
            width: 2.6rem;
            // height: 1.79rem;
            cursor: pointer;
            margin-right: 0.15rem;

            .cover_item {
              width: 2.6rem;
              height: 1.63rem;
              position: relative;
              .img_box {
                position: relative;
                width: 2.6rem;
                height: 1.63rem;
                border-radius: 0.109rem;
                overflow: hidden;          /* 让蒙版不会溢出圆角 */
              }

                .img_box img {
                  width: 100%;
                  height: 100%;
                  display: block;
                  border-radius: inherit;
                }
                .img_box:hover .mask {
                  opacity: 1;
                  transform: translateY(0);
                }
                .collect {
                    position: relative;
                    z-index: 999;
                    bottom: 1.6rem;
                    left: 2.2rem;
                    width: 0.29rem;
                    height: 0.29rem;
                    .collectimg {
                      width: 100%;
                      height: 100%;
                      display: block;
                    }
                }
              }
            .title {
              // font-size: 18px;
              font-size: 0.18rem;
              color: #3d3d3d;
              margin-top: 0.10rem;
            }
          }
          .list_item:nth-child(4n){
            margin-right: 0;
          }

          /* 悬停出现 */
          // .list_item:hover .mask {
          //   transform: translateY(0);
          //   opacity: 1;
          // }
        }
      }
      .six {
       width: 8.74rem;
        height: 2.8rem;
        background-image: url(@/assets/image/center6.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-top: 0.3rem;
      }
    }

    .mask {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      // background: rgba(0, 0, 0, 0.55);
      background: #fff;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translateY(100%);
      opacity: 0;
      transition: opacity 0.3s;
      pointer-events: none;
      padding: 0 0.10rem;
      overflow: hidden;
    }
    /* 文字 */
    .mask-txt {
      color: #000;
      font-size: 0.14rem;
      line-height: 1.5;
    }
    .mask-txt p {
      margin: 0 0 0.04rem;
    }
    .mask-txt p:last-child {
      margin-bottom: 0;
    }
    .content_right {
      width: 15%;
      width: 15%;
      // width: 200px;
      height: 9.59rem;
      background: url(@/assets/image/right.png) center center no-repeat;
      border: 0.06rem solid #836c4e;
      border-radius: 0.1rem;
      .pushtext {
        width: 1.54rem;
        height: 0.61rem;
        margin: auto;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .push_list {
        margin-top: 0.2rem;
        .push_item {
          cursor: pointer;
          margin-top: 0.18rem;
          .push_cover {
            width: 1.5rem;
            height: 1.01rem;
            margin: auto;
            img {
              width: 100%;
              height: 100%;
              border-radius: 0.1rem;
            }
          }
          .title {
            width: 1.4rem;
            // font-size: 16px;
            font-size: 0.16rem;
            text-align: center;
            color: #3d3d3d;
            margin: auto;
            margin-top: 0.1rem;
          }
        }
      }
      .seemore {
        width: 1.3rem;
        height: 0.42rem;
        margin: auto;
        margin-top: 0.3rem;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }
}
.ellipsis {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.smallsize {
   font-size:0.14rem;
   width: 2.1rem;
  //  border: 1px solid red;
}
.title_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .more {
    margin-right: 0.25rem;
    display: flex;
    font-size: 0.16rem;
    color: #666666;
    cursor: pointer;
    img {
    width: 0.32rem;
    height: 0.2rem;
    margin-left: 0.06rem;
    }
  }
}
.title_content {
  font-family: 'myFont';
  width: 1.54rem;
  height: 0.61rem;
  margin-top: 0.09rem;
  margin-left: 0.37rem;
  // font-size: 25px;
  font-size: 0.29rem;
  line-height: 0.65rem;
  text-align: center;
}

.oneimg {
  background: url(@/assets/image/title1.png) center center no-repeat;
  background-size: 100% 100%;
}
.twoimg {
  background: url(@/assets/image/title2.png) center center no-repeat;
  background-size: 100% 100%;
}
.threeimg {
  background: url(@/assets/image/title3.png) center center no-repeat;
  background-size: 100% 100%;
}
.fourimg {
  background: url(@/assets/image/title4.png) center center no-repeat;
  background-size: 100% 100%;
}
.fiveimg {
  background: url(@/assets/image/title5.png) center center no-repeat;
  background-size: 100% 100%;
}
.siximg {
  background: url(@/assets/image/title6.png) center center no-repeat;
  background-size: 100% 100%;
}
.blue {
  color: #00a0ff;
}
.brown {
  color: #765021;
}
.pink {
  color: #ff0000;
}
.skyblue {
  color: #72b7dc;
}
.cyan {
  color: #4b3331;
}
.yellow {
  color: #ff5900;
}
/deep/ .el-message {
  font-size: 14px !important;        /* 文字 */
  padding: 12px 16px !important;     /* 内间距 */
  border-radius: 4px !important;     /* 圆角 */
  line-height: 1.5 !important;
}
/deep/ .el-message__icon {
  font-size: 14px !important;
  margin-right: 8px !important;
}
/deep/ .el-message__closeBtn {
  font-size: 14px !important;
}
</style>
